import { Component, OnInit, ChangeDetectorRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper } from './../../../../helper';
import { DatePipe } from '@angular/common';

import { CustomerSummaryService } from '../../customer';
import { ReportDetailService } from './report-detail.service';

import { IsActive } from './../../../../model';
import { Report } from '../report';

import * as $ from 'jquery';

@Component({
  selector: 'app-report-detail',
  templateUrl: './report-detail.component.html',
  styleUrls: [
    '../../../../../scss/vendors/bs-datepicker/bs-datepicker.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class ReportDetailComponent implements OnInit {

  @ViewChild('dangerModal') dangerModal: any;

  customerChecked = false;
  dateChecked = false;
  disabledDate = true; // default disabled date checkbox
  incompletedJobsChecked = false;
  reports: any[];

  customerId;
  customer: Array<any> = [];
  customers = [];

  dropdownSettings = {};

  bsRangeValue = [];
  startDate;
  endDate;

  reportId = '';
  report: any;

  redirect = true;

  flag = false;

  constructor(
    private datePipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private customerSummaryService: CustomerSummaryService,
    private reportDetailService: ReportDetailService,
    private chRef: ChangeDetectorRef,
    ) {
      this.route.params.subscribe(params => {
        this.reportId = params['id'];
      });
      this.translate.setDefaultLang('en-us');
    }

  ngOnInit() {

    this.reports = Report;

    for (const report of this.reports) {
      if (report.id === this.reportId) {
        this.report = report;
        if (this.report.showCustomer || this.report.showDate) {
          this.getCustomerSummary();

        }

        if (this.report.showDate) {
          // default true
          this.dateChecked  = true
          
          // default filter last one year
          let d = new Date()
          d.setFullYear(d.getFullYear() - 1)
          this.bsRangeValue = [d, new Date()];
          this.filterChange();

          if (this.report.disabledDate != null) {
            this.disabledDate = this.report.disabledDate
          }
        }
      }

    }
  }

  getCustomerSummary() {
    this.dropdownSettings = {
      singleSelection: true,
      text: "Select Customer",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      labelKey: "shortName",
      disabled: true
    };

    this.customerSummaryService.getSummary(IsActive.active)
      .subscribe((data: any) => {
        this.customers = data.customerListModel;

        $('.filter-row').css('padding-bottom', '260px') ;

        $('div.c-btn').attr('id', 'single-select');

      }, error => {
        this.exception.showError(error, 'showDanModalBtn');
        this.redirect = true;
      });

  }

  checkboxChange() {
    if (this.customerChecked === true) {
      this.dropdownSettings = {
      singleSelection: true,
      text: "Select Customer",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: "shortName",
      disabled: false
      };

      $('#download').attr('disabled', 'disabled');
    }
    else {
      this.customer = [];
      this.customerId = null;

      this.dropdownSettings = {
      singleSelection: true,
      text: "Select Customer",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: "shortName",
      disabled: true
      };

    }

    if (this.dateChecked === true) {
      $('#download').attr('disabled', 'disabled');
    }
    else {
      this.bsRangeValue = [];
      this.startDate = null;
      this.endDate = null;
    }

    if (this.check() === true) {
      $('#download').removeAttr('disabled');
    }

  }

  onItemSelect(item: any) {
    if (this.customer.length !== 0) {
      this.customerId = this.customer[0].id;

      if (this.check() === true) {
        $('#download').removeAttr('disabled');
      }
    }
  }

  OnItemDeSelect(item: any) {
    this.customerId = null;
    $('#download').attr('disabled', 'disabled');
  }

  filterChange() {

    if (this.bsRangeValue[1] != null) {
      this.startDate = this.datePipe.transform(this.bsRangeValue[0], 'yyyy-MM-dd');
      this.endDate = this.datePipe.transform(this.bsRangeValue[1], 'yyyy-MM-dd');

      if (this.check() === true) {
        $('#download').removeAttr('disabled');
      }
    }
    else {
      this.startDate = null;
      this.endDate = null;
      $('#download').attr('disabled', 'disabled');

    }
  }

  check() {
    if (this.customerChecked && this.customer.length !== 0
      && this.dateChecked && this.bsRangeValue[1] != null) {
      return true;
    }
    else if (this.customerChecked && this.customer.length !== 0 && !this.dateChecked) {
      return true;
    }
    else if (this.dateChecked && this.bsRangeValue[1] != null && !this.customerChecked) {
      return true;
    }
    else if (!this.customerChecked && !this.dateChecked) {
      return true;
    }
    else {
      return false;
    }
  }


  download() {
    if (this.reportId === 'survey') {
      this.downloadSurveyReport();
    } else {
      this.downloadNonSurveyReport();
    }

  }

  downloadNonSurveyReport() {
    if (this.flag) {
      return;
    }
    this.flag = true;

    const incompletedJobs = this.incompletedJobsChecked ? 1 : 0

    console.log(incompletedJobs);
    this.reportDetailService.getReport(this.reportId, this.customerId, this.startDate, this.endDate, incompletedJobs).subscribe( (data) => {

      const head = data.headers.get('content-disposition');
      const filename = decodeURI( head.replace('attachment;filename=', '') );
      const file = new Blob([data.body], {type: "application/vnd.ms-excel;charset=utf-8"});

      if (window.navigator.msSaveOrOpenBlob) {// IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
      }
      else { // Others
        const a = document.createElement("a");
        const url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
          document.body.removeChild(a); window.URL.revokeObjectURL(url);
        }, 0);

        this.flag = false;
      }


    },
    error => {
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;
      this.flag = false;
    });
  }

  downloadSurveyReport() {
    this.reportDetailService.getSurvey(this.startDate, this.endDate, this.customerId).subscribe(data => {
      const head = data.headers.get('content-disposition');
      const filename = decodeURI( head.replace('attachment;filename=', '') );
      const file = new Blob([data.body], {type: "application/vnd.ms-excel;charset=utf-8"});

      if (window.navigator.msSaveOrOpenBlob) {// IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
      } else { // Others
        const a = document.createElement("a");
        const url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
          document.body.removeChild(a); window.URL.revokeObjectURL(url);
        }, 0);

        this.flag = false;
      }
    }, error => {
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;
      this.flag = false;
    });
  }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/report']);
    }
    else {
      this.dangerModal.hide();
    }

  }



}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/report/report-detail/report-detail.component.ts